//#region src/js/search.js
var SearchForm = class extends HTMLElement {
	connectedCallback() {
		if (this.initialized) return;
		this.initialized = true;
		this.input = this.querySelector("input[type=\"search\"]");
		if (this.input?.form) {
			this.input.form.addEventListener("reset", this.onFormReset.bind(this));
			this.input.addEventListener("input", debounce((event) => {
				this.onChange(event);
			}, 300).bind(this));
		}
	}
	onChange() {
		console.log("predictive search is active");
	}
	shouldResetForm() {
		return !document.querySelector("[aria-selected=\"true\"] a");
	}
	onFormReset(event) {
		event.preventDefault();
		if (this.shouldResetForm()) {
			this.input.value = "";
			this.input.focus();
		}
	}
};
customElements.define("search-form", SearchForm);
//#endregion
